import * as H from 'history';
import { singleItemDefaultConfig } from '../singleitemdisplay/SingleItemDisplay';

export const getControlledDefaultConfig =  (history: H.History) => ({
    ...singleItemDefaultConfig,
    header: 'Game Stats'
})